var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('NavBar'),_c('v-main',[_c('transition',{attrs:{"name":_vm.$route.meta.transition,"mode":"out-in"}},[_c('router-view',{staticClass:"page-component",on:{"transition":_vm.changeTransition}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }